import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateStatementPdfsSideEffectContext = BaseLoanIdSideEffect.extend({
  statements: z.array(
    z.object({
      paymentDueId: PaymentDueId,
      disableMailTask: z.boolean().optional(),
    }),
  ),
});
export const GenerateStatementPdfsSideEffect = GenerateStatementPdfsSideEffectContext.extend({
  type: z.literal('generateStatementPDFs'),
});
export type GenerateStatementPdfsSideEffect = z.infer<typeof GenerateStatementPdfsSideEffect>;
